import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import NavPage from "@/layouts/nav-header";
import UnifiedConfirmView from "./components/unified-confirm-view";

export default function ConfirmPage() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <NavPage isForm={0}>
      <main className="flex min-h-screen flex-col items-center justify-center p-4 sm:p-6">
        <section className="w-full max-w-md bg-primary-white p-5 shadow-xl rounded-md sm:max-w-lg">
        <h1 className="text-2xl font-semibold">
          {t("authentication.messages.confirmEmail")}
        </h1>
          <UnifiedConfirmView />
      </section>
      </main>
    </NavPage>
  );
}
